<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-pencil"></i> Premade Comments</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
                <router-link v-bind:to="{name: 'add-premade-comment' }" class="button is-info is-pulled-right">Add new</router-link>
            </div>
            <div class="column">
                <premade-comments-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="premadeComments" v-bind:actions="true"></premade-comments-table>
            </div>
        </div>          
    </div>  
</template>

<script>
import lodash from 'lodash'
import PremadeCommentsTable from "./Table";

export default {
  name: 'premade-comments-view',
  components: {PremadeCommentsTable},
  data() {
        return {
            premadeComments: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
        }
  },
  created(){
    this.getPremadeComments();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getPremadeComments();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getPremadeComments();
    },
    onPageChanged(page){
        this.page = page;        
        this.getPremadeComments();
    },
      getPremadeComments(){
          let  data = {
              page: this.page,
              q: this.q,
              orderBy:this.orderBy
          };
        this.premadeCommentRepo.paginate(data).then(response => {
            this.premadeComments = response.data.data;
            this.total = response.data.meta.pagination.total_pages            
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/premade-comments/View.vue